import { graphql } from 'react-relay';

export const revokeCancel = graphql`
  mutation revokeCancelMutation($refundId: String!) {
    revokeCancel(refundId: $refundId) {
      result
      errors {
        code
        message
      }
    }
  }
`;
